import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.scss';
import Home from '@/screens/Home/Home';
import AllTemplates from '../AllTemplates/AllTemplates';

function App() {
	return (
		<Router>
			<Switch>
				<Route path='/about'>
					<About />
				</Route>
				<Route path='/users'>
					<Users />
				</Route>
				<Route path='/templates'>
					<AllTemplates />
				</Route>
				<Route path='/'>
					<Home />
				</Route>
			</Switch>
		</Router>
	);
}

function About() {
	return <h2>About</h2>;
}

function Users() {
	return <h2>Users</h2>;
}

export default App;
